/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useCallback, useContext, useState } from 'react';
import { DialogContent, Dialog, Grid, DialogTitle, Typography, Divider, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddEmployeeHeader from '../../../../../BusinessSettings/Components/Meetings/ManagementMeetings/Components/ManageHosts/Components/AddHosts/AddHostsHeader';
import { LanguageContext } from '../../../../../../libs/Context';
import { createFeedContext } from '../CreationPopup';
import { useSelector } from 'react-redux';
import EventCardNew from './Components/EventCardNew';

const Occasion = (props) =>
{
	const { openOccasion, handleClose } = props;
	const userData = useSelector((state:any) => state?.mysession?.session);

	// Contexts
	const { language } = useContext(LanguageContext);
	const { setCreateFeed } = useContext(createFeedContext);

	// State
	const [ openPopup, setOpenPopup ] = useState<any>(null);
	const [ occasionData, setOccasionData ] = useState<any>({});

	const handleClick = (value, textVal) =>
		{
			setOpenPopup({ val: value, text: textVal });
			handleClose();
		};

	const isIndividual = userData?.role === 'individual';
	const stepVal = isIndividual ? 2 : 1;

	// Event_Type
	const items = [
		{ key: 'occasionT', lang: language?.occasion, text: 'Occasion', val: stepVal },
		{ key: 'eventT', lang: language?.event, text: 'Event', val: stepVal },
		{ key: 'certificationT', lang: language?.certification, text: 'Certification', val: stepVal }

	];

	// phase -4
	const updateCreateFeed = useCallback((updData) =>
	{
		const title = `Celebrating ${openPopup?.text || ''}`;

		setCreateFeed((prev) => ({
			...prev,
			occasion     : { ...{ ...occasionData, ...updData }, type: openPopup?.text, title },
			taggedPeople : [ ...(occasionData?.employees || []), ...(updData?.employees || []) ]
		}));
	}, [ occasionData, openPopup ]);

	// phase - 2
	const updateOccassionData = useCallback(async (obj, val) =>
	{
		setOccasionData((prev) => ({ ...prev, ...obj }));
		updateCreateFeed(obj);
	}, [ occasionData, updateCreateFeed ]);

	// phase -1
	const handleNext = (obj:any, val:any) =>
	{
		updateOccassionData(obj, val);
		setOpenPopup({ val, text: openPopup?.text });
		handleClose();
	};

	const handleCloseHeader = (val, type) =>
	{
		setOpenPopup((prev) => ({ ...prev, val: type === 'empHeader' ? val : isIndividual ? 0 : val }));
		setOccasionData({});
		setCreateFeed((prev) =>
		{
			const updateActions = { ...prev };

			delete updateActions.occasion;
			delete updateActions.taggedPeople;

            return updateActions;
		});
	};

	return (
		<>
			<Dialog
				open={openOccasion}
				onClose={handleClose}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				fullWidth
				maxWidth='sm'
			>
				<DialogTitle>
					<Grid container display={'flex'} alignItems={'center'} pb='var(--pixel8)'>
						<Grid item xs >
							<Typography fontWeight='var(--font500)'>{language?.celebration}</Typography>
						</Grid>
						<Grid item display={'flex'} alignItems={'center'} onClick={handleClose} >
							<CloseIcon className='lightTxt pointer' />
						</Grid>
					</Grid>
				</DialogTitle>
				<DialogContent>
					<Grid container spacing={2}>
						<Grid item xs={12} p='var(--pixel8)'>
							<Stack
								flexDirection='column'
								sx={{
									width        : 'var(--percent100)',
									boxShadow    : 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
									borderRadius : '13px'
								}}
								spacing={2}
								p='var(--pixel16)'
							>
								{items?.map((item, index) => (
									<React.Fragment key={item?.key}>
										<Typography
											fontWeight='var(--font500)'
											sx={{ cursor: 'pointer' }}
											onClick={() => handleClick(item?.val, item?.text)}
										>
											{item?.lang}
										</Typography>
										{index < items.length - 1 && <Divider sx={{ color: 'rgba(195, 195, 195, 1)' }} />}
									</React.Fragment>
								))}
							</Stack>
						</Grid>
					</Grid>
				</DialogContent>
			</Dialog>
			{openPopup?.val === 1 &&
			<AddEmployeeHeader
				open={Boolean(openPopup?.val === 1)}
				onClose={() => handleCloseHeader(0, 'empHeader')}
				// setOpenPopup((prev) => ({ ...prev, val: 0 }));
				// setOccasionData({});
				// setCreateFeed((prev) => ({ ...prev, occasion: {}, taggedPeople: [] }));
				handleNext={handleNext}
				// feedType='newRequest'
				from='newsFeed'
				title={language.selectEmployee}
			/>}
			{openPopup?.val === 2 &&
			// <SelectEventTemp
			<EventCardNew
				open={Boolean(openPopup?.val === 2)}
				handleCloseTemp={(val) => handleCloseHeader(val, 'eventCard')}
				// handleCloseTemp={(val:any) =>
				// {
				// 	console.log('***caaling');
				// 	setOpenPopup((prev) => ({ ...prev, val: isIndividual ? 0 : val }));
				// 	setOccasionData({});
				// 	setCreateFeed((prev) => ({ ...prev, occasion: {}, taggedPeople: [] }));
				// }}
				handleNext={handleNext}
			/>}
		</>
	);
};

export default Occasion;
